import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ConsignmentsViewpointToggleProps {
  // true = every location group of the project, false = the current one only
  allSites: boolean;
  onChange: (allSites: boolean) => void;
}

/**
 * Header control switching the consignments list between the project-wide and
 * the location-group viewpoint. Registered into the header's `actions` slot by
 * the consignments page, so it appears on that page only.
 */
export function ConsignmentsViewpointToggle({ allSites, onChange }: ConsignmentsViewpointToggleProps) {
  const { t } = useTranslation();

  const viewpoint = allSites
    ? t('location.project.label', 'Project')
    : t('location.parentSite.label', 'Location Group');
  const label = `${t('cmrlist.change.viewpoint.label', 'Change Viewpoint')}: ${viewpoint}`;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9"
      aria-label={label}
      title={label}
      aria-pressed={allSites}
      onClick={() => onChange(!allSites)}>
      {allSites ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
    </Button>
  );
}
